"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwoFactorVerifyDTO = exports.TwoFactorChallengeDTO = exports.TwoFactorSetupDTO = exports.EmailVerificationCompleteDTO = exports.EmailVerificationSendDTO = exports.AccountGameIdLinkDTO = void 0;
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
const class_validator_1 = require("class-validator");
let AccountGameIdLinkDTO = class AccountGameIdLinkDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.AccountGameIdLinkDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala User Id'),
    __metadata("design:type", String)
], AccountGameIdLinkDTO.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('An Id assigned to a user from one our games that will link a Gala Platform User Id.'),
    __metadata("design:type", String)
], AccountGameIdLinkDTO.prototype, "gameId", void 0);
AccountGameIdLinkDTO = __decorate([
    (0, decorators_1.Describe)('An event that is used to link an Id from one of our games to a Gala Account User Id.')
], AccountGameIdLinkDTO);
exports.AccountGameIdLinkDTO = AccountGameIdLinkDTO;
let EmailVerificationSendDTO = class EmailVerificationSendDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.EmailVerificationSendDTO) {
};
EmailVerificationSendDTO = __decorate([
    (0, decorators_1.Describe)('User email verification requested')
], EmailVerificationSendDTO);
exports.EmailVerificationSendDTO = EmailVerificationSendDTO;
let EmailVerificationCompleteDTO = class EmailVerificationCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.EmailVerificationCompleteDTO) {
};
EmailVerificationCompleteDTO = __decorate([
    (0, decorators_1.Describe)('User email verification completed successfully')
], EmailVerificationCompleteDTO);
exports.EmailVerificationCompleteDTO = EmailVerificationCompleteDTO;
let TwoFactorSetupDTO = class TwoFactorSetupDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TwoFactorSetupDTO) {
};
TwoFactorSetupDTO = __decorate([
    (0, decorators_1.Describe)('User set up 2fa')
], TwoFactorSetupDTO);
exports.TwoFactorSetupDTO = TwoFactorSetupDTO;
let TwoFactorChallengeDTO = class TwoFactorChallengeDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TwoFactorChallengeDTO) {
};
TwoFactorChallengeDTO = __decorate([
    (0, decorators_1.Describe)('User presented with 2fa challenge')
], TwoFactorChallengeDTO);
exports.TwoFactorChallengeDTO = TwoFactorChallengeDTO;
let TwoFactorVerifyDTO = class TwoFactorVerifyDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TwoFactorVerifyDTO) {
};
TwoFactorVerifyDTO = __decorate([
    (0, decorators_1.Describe)('User successfully verified via 2fa')
], TwoFactorVerifyDTO);
exports.TwoFactorVerifyDTO = TwoFactorVerifyDTO;
